import { toast } from 'react-toastify';

import { isArray } from 'lodash';
import moment from 'moment';
import qs from 'querystring';
import { takeLatest, call, put, all } from 'redux-saga/effects';

import { t } from '~/helpers';
import api from '~/services/api';
import history from '~/services/history';

import {
  successInRequest,
  failedRequest,
  successRemove,
  successRequest,
} from './actions';

export function* requestOperacaoAfericao({ payload }) {
  try {
    const { params } = payload;
    const response = yield call(api.get, 'afericoes', {
      params,
      paramsSerializer: (param) => qs.stringify(param),
    });
    const { items, page, pageSize, totalCount, totalPages } = response.data;

    yield put(successInRequest(items, page, pageSize, totalCount, totalPages));
  } catch (erros) {
    yield put(failedRequest());
    if (isArray(erros)) erros.map((e) => toast.error(e));
    else toast.error(erros);
  }
}

export function* deleteOperacaoAfericao({ payload }) {
  try {
    const { idoperacaoafericao, params, query } = payload;

    yield call(api.delete, `afericoes/${idoperacaoafericao}`, {
      params: query,
    });
    yield put(successRemove({ ...params, pesquisalista: true }));

    toast.success(t('s.geral.sucessoexclusao'));
  } catch (erros) {
    yield put(failedRequest());
    if (isArray(erros)) erros.map((e) => toast.error(e));
    else toast.error(erros);
  }
}

export function* store({ payload }) {
  try {
    const { operacaoafericao, params } = payload;

    yield call(api.post, 'afericoes/', operacaoafericao);
    yield put(successRemove({ ...params, pesquisalista: true }));

    toast.success(t('s.geral.sucessoinclusao'));
    history.push('/afericoes');
  } catch (erros) {
    yield put(failedRequest());
    if (isArray(erros)) erros.map((e) => toast.error(e));
    else toast.error(erros);
  }
}

export function* find({ payload }) {
  try {
    const { idoperacaoafericao } = payload;

    const { data } = yield call(api.get, `afericoes/${idoperacaoafericao}`);

    yield put(successRequest(data));
  } catch (erros) {
    yield put(failedRequest());
    if (isArray(erros)) erros.map((e) => toast.error(e));
    else toast.error(erros);
  }
}

export function* update({ payload }) {
  try {
    const { operacaoafericao, params } = payload;

    yield call(api.put, 'afericoes', operacaoafericao);
    yield put(successRemove({ ...params, pesquisalista: true }));

    toast.success(t('s.geral.sucessoalteracao'));
    history.push('/afericoes');
  } catch (erros) {
    yield put(failedRequest());
    if (isArray(erros)) erros.map((e) => toast.error(e));
    else toast.error(erros);
  }
}

export function* applyedFilters({ payload }) {
  try {
    const { params } = payload;

    const response = yield call(api.get, 'afericoes', {
      params,
      paramsSerializer: (param) => qs.stringify(param),
    });

    const { items, page, pageSize, totalCount, totalPages } = response.data;

    yield put(successInRequest(items, page, pageSize, totalCount, totalPages));
  } catch (erros) {
    yield put(failedRequest());
    if (isArray(erros)) erros.map((e) => toast.error(e));
    else toast.error(erros);
  }
}

export default all([
  takeLatest(
    '@operacaoafericao/OPERACAOAFERICAO_IN_REQUEST',
    requestOperacaoAfericao
  ),
  takeLatest(
    '@operacaoafericao/DELETE_OPERACAOAFERICAO',
    deleteOperacaoAfericao
  ),
  takeLatest('@operacaoafericao/SUCCESS_REMOVE', requestOperacaoAfericao),
  takeLatest('@operacaoafericao/STORE_OPERACAOAFERICAO', store),
  takeLatest('@operacaoafericao/FIND_OPERACAOAFERICAO', find),
  takeLatest('@operacaoafericao/UPDATE_OPERACAOAFERICAO', update),
  takeLatest('@operacaoafericao/RECORD_FILTERING', applyedFilters),
]);
